// API Configuration
// Use relative path by default (works with Apache proxy)
// Override with VITE_API_URL environment variable if needed
export const API_URL = import.meta.env.VITE_API_URL || '/api'; 